import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { divWithStyle } from '../style/LayoutComponents';
import { vizPortalFontStyle } from '../style/VizPortalStyles';
import { isIE } from '../utils/BrowserDetection';

export const dialogWidth = 300;

export const ColumnDescriptionWrapper = divWithStyle('ColumnDescriptionWrapper', {
  backgroundColor: TabStyles.Colors.White,
  borderColor: TabStyles.Colors.L5,
  borderRadius: TabStyles.Sizing.BorderRadius,
  borderStyle: 'solid',
  borderWidth: TabStyles.Sizing.BorderWidth,
  boxShadow: TabStyles.Shadow.Elevated,
  cursor: 'default',
  display: 'flex',
  flexDirection: 'column',
  ...(isIE && { overflowY: 'auto' }),
});

export const ColumnDescriptionPane = divWithStyle('ColumnDescriptionPane', {
  ...vizPortalFontStyle,
  fontSize: TabStyles.Typography.Sizing.Default,
  margin: '16px',
  maxWidth: '300px',
});

export const ColumnDescriptionFieldName = divWithStyle(
  'ColumnDescriptionFieldName',
  {
    fontSize: TabStyles.Typography.Sizing.XLarge,
    margin: '8px 0',
  }
);

export const ColumnDescriptionCell = divWithStyle('ColumnDescriptionCell', {
  padding: '16px 0 0',
});

export const ColumnDescriptionInheritedColumnRow = divWithStyle(
  'ColumnDescriptionInheritedRow',
  { display: 'table' }
);

export const ColumnDescriptionInheritedTableRow = divWithStyle(
  'ColumnDescriptionInheritedRow',
  { display: 'table', paddingTop: '8px' }
);

export const DescriptionLabel = divWithStyle('DescriptionLabel', {
  fontSize: TabStyles.Typography.Sizing.Default,
  fontWeight: 'bold',
});

export const DescriptionText = divWithStyle('DescriptionText', {
  fontSize: TabStyles.Typography.Sizing.Default,
  marginTop: '8px',
});

export const InheritedDetailsLabel = divWithStyle('InheritedDetailsLabel', {
  display: 'table-cell',
  color: TabStyles.Typography.Color.Secondary,
  paddingRight: TabStyles.Spacing.SmallSpace,
  textAlign: 'right',
  whiteSpace: 'nowrap',
  verticalAlign: 'top',
});

export const InheritedDetailsValue = divWithStyle('InheritedDetailsValue', {
  maxWidth: '300px',
  maxHeight: '150px',
  overflow: 'auto',
});

export const InheritedRow = divWithStyle('InheritedRow', {
  display: 'table-row',
});

export const DescriptionDialogBodyStyle: React.CSSProperties = {
  padding: '0px',
};

export const AssetParentIconStyle: React.CSSProperties = {
  padding: '0 3px',
  verticalAlign: 'top',
};
